module.exports = __webpack_public_path__ + "static/features-4-1dc2ddc02e59f197db4aa986da9b35ac.svg";